import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { renderSafeMarkdown } from '../../utils/safeMarkdown';

interface AwardEntry {
  type?: string;
  publicationText?: string;
}

interface AwardsSectionProps {
  additionalInfoData: Record<string, unknown> | null;
}

export const AwardsSection: React.FC<AwardsSectionProps> = ({ additionalInfoData }) => {
  const entries = (additionalInfoData?.exhibitions as AwardEntry[] | undefined) ?? [];
  const awards = entries.filter(
    (e) => e.type === 'award' && (e.publicationText ?? '').trim() !== '',
  );

  if (awards.length === 0) return null;

  return (
    <Accordion data-testid="awards-section">
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h3">Awards &amp; Honors</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ pl: 1 }}>
          {awards.map((award, idx) => (
            <Box key={idx} sx={{ mb: 1.5 }}>
              <Typography variant="body1">
                {renderSafeMarkdown(award.publicationText)}
              </Typography>
            </Box>
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
